<template>
  <div>
    <template v-if="past">
      <EmptySpace
        illustration="no_history_goals.svg"
        subheader="What happened that month? Was it a good or bad month? By planning and recording your progress, you will ensure that you will never forget your magnificent progress on your journey."
        subsubheader="Don't worry, you are on the right path now.">
        <template v-slot:header><h2>You didn’t add anything<br>in {{monthInWords}}</h2></template>
      </EmptySpace>
    </template>
    <template v-else>
      <EmptySpace
        illustration="no_planned_goals.svg"
        subheader="An hour of planning can save you days of doing."
        subsubheader="Even small steps will get you there eventually. Start small, dream big and you will never stay small.">
        <template v-slot:header><h2>What are you planning to do this month to come closer to your dreams?</h2></template>
      </EmptySpace>
    </template>
  </div>

</template>

<script>
import EmptySpace from '../Preview/EmptySpace'

export default {
  components: {
    EmptySpace
  },
  props: {
    past: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    monthInWords: {
      type: String,
      required: true,
    },
  }
}
</script>

<style>
  p.emphasize {
    font-size: 130%;
  }
</style>
